// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Rhl3","title":"Info_title__F5hpJ","selects":"Info_selects__3bXSb","requiredAsterisk":"Info_requiredAsterisk__4npZL"};